import { Injectable } from '@angular/core';
import { ApiService } from '@shared/services/api.service';
import { ICommunication } from '@shared/interfaces/communication/ICommunication';
import { IPaginatedResult } from '@shared/interfaces/mailing/IPaginatedResult';
import { IQueryCommunication } from '@shared/interfaces/queries/IQueryCommunication';
import { convertQueryToParams } from '@shared/helpers/query-converter';

@Injectable({
    providedIn: 'root'
})
export class CommunicationService {
    constructor(private apiService: ApiService) {}

    get lastQueriedNotificationDate(): string {
        const date = localStorage.getItem('lastQueriedNotificationDate');
        return (date ? new Date(JSON.parse(date)) : new Date()).toISOString();
    }

    async getAll(query: IQueryCommunication = {}): Promise<IPaginatedResult<ICommunication>> {
        const result = await this.apiService.get(`/communication${convertQueryToParams<IQueryCommunication>(query)}`);

        if (query.pagination.page === 0) {
            localStorage.setItem('lastQueriedNotificationDate', JSON.stringify(new Date()));
        }

        return result;
    }

    async getUnreadMessagesCount(): Promise<number> {
        return await this.apiService.get(`/communication/unread-messages`);
    }

    async poll(query: IQueryCommunication = {}): Promise<Array<ICommunication>> {
        query.minTime = this.lastQueriedNotificationDate;
        const result = await this.apiService.get(
            `/communication/poll${convertQueryToParams<IQueryCommunication>(query)}`
        );
        localStorage.setItem('lastQueriedNotificationDate', JSON.stringify(new Date()));
        return result;
    }

    addSeenBy(): Promise<void> {
        return this.apiService.put(`/communication/seen`, {});
    }
}
